import React from 'react';
import './gadaad.css';



const Gadaad = () => {
    return (
        <main> 
            <h1>Гадаад харилцаа</h1>
        </main>
    )
}
export default Gadaad;